angular
  .module("kareo.ui.shared.directives.patient-payment-config", ['kareo.ui.shared.directives.patient-payment-data', 'kareo.ui.shared.modules.featureSet'])

.controller("PaymentConfigController",
  ['$scope', '$rootScope', '$log', '$state', 'featureSet', 'PatientPaymentData', '$window', 'authenticatedUser', 'stripeCode'
    ($scope, $rootScope, $log, $state, featureSet, PatientPaymentData, $window, authenticatedUser, stripeCode) ->
      $scope.AUTH__ADMIN = 21 # auth id 21: Clinic Settings - enterprise
      $scope.settings = {}
      $scope.displayDirective = false
      $scope.load = {}
      $scope.state =
        showTerms: false
      $scope.sync =
        isLoading: ->
          _.any($scope.load)
        stripeUrl: false
        acceptTerms: false
        enablePayments: false


      featureSet.load().then( (features) ->
        PatientPaymentData.getSettings()
        .then( (response) ->
          $scope.settings = response.data
          $rootScope.$broadcast('stripe-settings', $scope.settings)
          checkStripeRegistration()
          $scope.displayDirective = true
          if features['dark-feature.kareo-collect-promotion']
            $scope.displayDirective = false
        , (response) ->
          $log.error(response.data)
        )
      )

      $scope.load.user = true
      authenticatedUser.get()
       .then( (user) ->
         $scope.user = user
         $scope.user.isAdmin = authenticatedUser.hasPrivilege($scope.AUTH__ADMIN)
       , (data, status) ->
         $log.error(data)
       )
       .finally( ->
         $scope.load.user = false
       )

      reloadSettings = ->
        PatientPaymentData.getSettings()
        .then( (response) ->
          $scope.settings.hasPaymentAccount = true
          $scope.settings.enabled = true
          $scope.settings.stripeKeys = response.data.stripeKeys
          $rootScope.$broadcast('stripe-settings', $scope.settings)
        , (response) ->
          $log.error(response.data)
        )

      checkStripeRegistration = ->
        if stripeCode.get() && $scope.settings.registered && !$scope.settings.hasPaymentAccount
          #loading state
          $scope.load.registerStripe = true

          PatientPaymentData.registerStripe(stripeCode.get())
          .then( (data)->
            if data
              reloadSettings()
          )
          .finally( (response)->
            $scope.load.registerStripe = false
          )

      gotoStripe = ->
        $scope.sync.stripeUrl = true
        PatientPaymentData.stripeRegistration()
        .then( (response) ->
          $window.location.href = response.data
        , (response) ->
          $scope.sync.stripeUrl = false
        )

      $scope.setupPaymentsClick = ->
        if $scope.settings.registered
          gotoStripe()
        else
          $scope.state.showTerms = true

      $scope.acceptTermsClick = ->
        $scope.sync.acceptTerms = true
        PatientPaymentData.registerPayments(true)
        .then( (response) ->
          $scope.settings.registered = true
          gotoStripe()
        )
        .finally( (data, status) ->
          $scope.sync.acceptTerms = false
        )

      $scope.enablePaymentsClick = ->
        $scope.sync.enablePayments = true
        PatientPaymentData.togglePayments(true)
        .then( (response) ->
          $scope.settings.enabled = true
          $rootScope.$broadcast('stripe-settings', $scope.settings) # we really need a model we can watch for changes
        )
        .finally( (data, status) ->
          $scope.sync.enablePayments = false
        )
  ]
)

.directive("patientPaymentConfig",
  [() ->
    restrict: "E"
    scope: {
      notDismissable: '='
    }
    replace: true
    template: require('./register.pug')()
    transclude: true
    controller: "PaymentConfigController"
])

.factory "stripeCode", [
  () ->
    stripeCode = ""
    return {
    get : ->
      return stripeCode
    set : (code) ->
      stripeCode = code
      return stripeCode
    }
]
